import { useSelector } from "react-redux";
import { reduce, get } from "lodash";

/**
 * Returns the current error for an action (or errors if actions is an array) or null if it doesn't have an error
 *
 * @example
 * // returns the error from GET_TODOS_FAILURE after it is dispatched and null after GET_TODOS_SUCCESS or GET_TODOS_BEGIN is dispatched
 * const error = useErrorState("GET_TODOS");
 * @param  {(string|string[])} actions - An action or list of actions to check for their error state
 * @return {Object|Object[]} Returns the error object for the provided action or an array of errors if actions is an array, null otherwise.
 */
const useErrorState = actions => {
  const errorsState = useSelector(state => state.errorsState);
  if (Array.isArray(actions)) {
    return reduce(
      actions,
      (errors, action) => {
        if (!!errorsState[action]) {
          errors.push(errorsState[action]);
        }
        return errors;
      },
      []
    );
  } else {
    return get(errorsState, actions);
  }
};

export default useErrorState;
